import Vue from 'vue'
import VueI18n from 'vue-i18n'

// register i18n module
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'jp',
  fallbackLocale: 'jp',
  messages: {
    jp: require('@/assets/languages/jp.json'),
    us: require('@/assets/languages/en.json')
  },
  silentTranslationWarn: true
})

const translate = (key, arg) => {
  if (!key) {
    return ''
  }
  return i18n.t(key, arg)
}

export { i18n, translate }
